import * as React from 'react';
import ExpiredDataComponent, { ExpiredDataComponentProps } from './ExpiredData.component';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import { connect, Dispatch } from 'react-redux';
import { openModal, OpenModal } from 'src/actions/modal';
import { RootState } from 'src/reducers/RootReducer';
import InvestmentFormContainer from 'src/modules/modals/investment-funnel/InvestmentForm.container';
import Project from 'src/entities/Project';

interface DispatchProps {
  openModal(component: JSX.Element, className?: string): void;
}

interface Props extends DispatchProps {
  project: Project;
  modalRef?: Modal;
}

class ExpiredDataContainer extends React.Component<Props> {

  public render(): React.ReactNode {
    return <ExpiredDataComponent {...this.getComponentProps()}/>;
  }

  private handleClick(): void {
    this.props.openModal(
      <InvestmentFormContainer/>
    );
  }

  private getComponentProps(): ExpiredDataComponentProps {
    return {
      project: this.props.project,
      modalRef: this.props.modalRef,
      handleClick: () => this.handleClick()
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  openModal: (component: JSX.Element, className?: string): OpenModal => (
    dispatch(openModal(component, className))
  )
});

export default connect(null, mapDispatchToProps)(ExpiredDataContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/expired-data/ExpiredData.container.tsx